import s from './style.module.scss';
const CircleBlink = () => {
    return (
        <>
            <div className={s['ring-wrapper']}>
                <div className={s['inner-ring']}></div>
                <div className={s['outer-ring']}></div>
            </div>
        </>
    );
};
export default CircleBlink;
